// extracted by mini-css-extract-plugin
export default {"field":"step-process_field__ELJTU","field_icon":"step-process_field_icon__fc-Fz"};